export default {"src":"/_next/static/media/0x4e3fbd56cd56c3e72c1403e103b45db9da5b9d2b.9880242c.svg","height":144,"width":124,"blurWidth":0,"blurHeight":0};